import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { TICKET_TYPE } from "@src/components/deungi/common/enum";
import { ownerCheckSingleIconWhite } from "../ui";
import { useTicketCount } from "@src/hooks/deungi/useTicketCount";
import { TicketCountResponseDto } from "@src/hooks/deungi/dto/Ticket.dto";
import { WebAppBridge } from "@src/lib/WebAppBridge";

interface ResponseData {
    data: TicketCountResponseDto;
}

const TicketCountBox = () => {
    const [ticketCount, setTicketCount] = useState<TicketCountResponseDto | null>(null);

    const fetchData = async () => {
        const response: ResponseData = await useTicketCount(TICKET_TYPE.OWNER_CHECK_TICKET);
        setTicketCount(response.data);
    };

    useEffect(() => {
        fetchData();
    }, []);

    // if success pay data refetching
    WebAppBridge.onPaymentSuccess = () => {
        fetchData();
    };

    return (
        <Container>
            <div className="ticketItem">
                <img src={ownerCheckSingleIconWhite} alt="소유자 확인 서비스 아이콘" width={38} height={38} />
                <h3>
                    소유자 확인 이용권
                    <label>{ticketCount?.curHaveCnt ?? 0}장</label>
                </h3>
            </div>
        </Container>
    );
};

export default TicketCountBox;

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background: #fff;
    box-sizing: border-box;
    width: 100%;
    gap: 10px;
    padding: 14px;

    & > div {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
    }

    .ticketItem {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        background: #f6faff;
        border-radius: 8px;
        transition: all 0.2s ease;
        padding: 10px;
        box-sizing: border-box;
        cursor: pointer;

        & > h3 {
            font-size: 13px;
            font-weight: 500;
            line-height: 1.4;
            width: max-content;
            min-width: 80px;
            text-align: center;
            margin: 4px auto 0;

            & > label {
                display: block;
                font-size: 16px;
                font-weight: 700;
                color: #0047ff;
                text-align: center;
                margin-top: 4px;
                cursor: pointer;
            }
        }
        & > img {
            background: #fff;
            border-radius: 4px;
            padding: 4px;
        }
    }
`;
